'use strict';

define('lib/analytics/blocks/list.item.block',[], function () {
  return function listItemBlock(index) {
    return {
      list_item_index: index + 1
    };
  };
});

